import React, { Component } from 'react';
import Header from '../Component/Header';
import Sidebar from '../Component/Sidebar';


class RefreshUrl extends Component {

    componentDidMount = () => {

      let is_stripe_connect = localStorage.getItem('is_stripe_connect') || null;
      if (is_stripe_connect) {
        //Return
      }
      else {
        this.props.history.push(`/franchise`);
      }
    }


    UNSAFE_componentWillReceiveProps = (props) => {

      //Update Franchise
      if (Object.keys(props.StripeLogin.data).length > 0 && props.StripeLogin.data !== this.props.StripeLogin.data) {
        window.open(props.StripeLogin.data?.url, '_blank');
      }

      if (Object.keys(props.StripeLogin.errors).length > 0 && props.StripeLogin.errors !== this.props.StripeLogin.errors) {
        // message.error('Something went wrong', 10);
        this.setState({
          loader: false,
        })
      }
    }

    render() {
      let temp_franchise = JSON.parse(localStorage.getItem('temp_franchise')) || null;
      return (
        <div id="wrapper">
          <div className="content-area">
            {/* Header */}
            <Header />

            {/* Sidebar */}
            <Sidebar history={this.props.history} />

            <div className="container">
              <div style={{ paddingTop: '100px', textAlign: 'center' }} >
                <h2>Something Went Wrong! <br />Please click on Retry button to proceed further</h2>
                <button className="btn btn-primary" onClick={() => { this.props.loginWithStripe(temp_franchise?.data?.uuid) }}>Retry</button>
              </div>
            </div>
          </div>

        </div >
      );
    }
}

export default RefreshUrl;